let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aDA8k")).then(() => parcelRequire('bpPEC'));